// extracted by mini-css-extract-plugin
export default {"cardContainerStyles":"styles_cardContainerStyles__DTWs8","titleTextStyles":"styles_titleTextStyles__JtwvO","descriptionTextStyles":"styles_descriptionTextStyles__Sjqk4"};